import React from "react";
import { render } from 'react-dom'
import HighchartsReact from 'highcharts-react-official';
import HighchartsSankey from 'highcharts/modules/sankey';
import HighchartsOrganization from 'highcharts/modules/organization';
import Highcharts from 'highcharts';
import './index.scss';

if (typeof Highcharts === 'object') {
  HighchartsSankey(Highcharts);
  HighchartsOrganization(Highcharts);
}





export default function AboutOrg(props) {
  
  const baseUrl = process.env.REACT_APP_BASE_URL
    const orgNodes = [];
    const orgData = [];
    orgNodes.push({
        id: props.chartData[0].id,
        parentId: props.chartData[0].parentId,
        name: props.chartData[0].name, 
        title: props.chartData[0].displayText,
        level: props.chartData[0].level,
        color: props.chartData[0].color, 
        offset: props.chartData[0].offset,
        image: props.chartData[0].image.urls[0] ? baseUrl + props.chartData[0].image.urls[0] : null
    });
    props.chartData[0].children.contentItems.map(i => {
        
        
        orgNodes.push(
            {
                id: i.id,
                parentId: i.parentId,
                name: i.name, 
                title: i.displayText,
                level: i.level,
                color: i.color, 
                offset: i.offset,
                image: i.image.urls[0] ? baseUrl + i.image.urls[0] : null
            }
        );
        if(i.children.contentItems[0]) {
            i.children.contentItems.map(j => {
               
                orgNodes.push(
                    {
                        id: j.id,
                        parentId: j.parentId,
                        name: j.name, 
                        title: j.displayText,
                        level: j.level,
                        color: j.color, 
                        offset: j.offset,
                        image: j.image.urls[0] ? baseUrl + j.image.urls[0] : null
                    }
                );
            })
        }
        
    })
    
    for (let index = 0; index < orgNodes.length; index++) {
        if  ( orgNodes[index].parentId) {
          orgData.push({from: orgNodes[index].parentId, to: orgNodes[index].id});
        }
        
      }
    const options = {
        chart: {
          inverted: true,
          height: 1400,
          style: {
            fontFamily: 'MyShFont',
            fontSize: 12
          },
          
        },
        title: {
          useHTML: true,
          text: "چارت سازمانی",
          style: {
            fontFamily: 'MyShFont'
          },
        },
        series: [
          {
            type: "organization",
            name: "Highsoft",
            keys: ["from", "to"],            
            colorByPoint: false,
            color: '#007ad0',
            dataLabels: {
                color: 'white'
            },
            borderColor: 'white',
            nodeWidth: 140,
            data: orgData,
            levels: [
              {
                level: 0,
                color: 'silver',
                dataLabels: {
                    color: 'black'
                }
            },{
              level: 1,
              color: 'silver',
              dataLabels: {
                  color: 'black'
              }
          }, {
              level: 2,
              color: '#980104',
              dataLabels: {
                color: 'black'
            }
          }, , {
            level: 3,
            color: '#980104',
            dataLabels: {
              color: 'black'
          }
        }, {
              level: 4,
              color: '#359154',
              dataLabels: {
                color: 'black'
            }
          },
          {
            level: 5,
            color: '#359154',
            dataLabels: {
              color: 'black'
          }
        },{
          level: 6,
          color: '#359154',
          dataLabels: {
            color: 'black'
        }
      },{
        level: 7,
        color: '#359154',
        dataLabels: {
          color: 'black'
      }
    }
            ],
            
            nodes: orgNodes,
          }
        ],
        exporting: {
          allowHTML: true,
          sourceWidth: 800,
          sourceHeight: 600
        },
        tooltip: {
          outside: true,
          backgroundColor: '#FCFFC5',
          useHTML: true,
          // formatter: function() {
          //   //debugger;
          //   return this.point.info;
          // }
        }
      }; 
  return (
   
    <HighchartsReact 
    highcharts={Highcharts}
    options={options}
  />
    
  );
}